import { gql } from "@apollo/client";
import useWrappedMutation from "../../common/data-fetching/useWrappedMutation";
import {JOB_TYPE_ALL_FIELDS_FRAGMENT} from "../view/useQueryJobById";
import {QUERY as QUERY_JOB_COUNTS_BY_STATUS} from "../search/useQueryJobCountsByStatus";

const QUERY_SCOPE = "job";
const QUERY_NAME = "jobUpdate";

export const QUERY = gql`
    ${JOB_TYPE_ALL_FIELDS_FRAGMENT}
    mutation ${QUERY_SCOPE}_${QUERY_NAME} (
        $id: ID!,
        $streetAddress: String,
        $postalCode: String,
        $city:String,
        $state: String,
        $country: String,
        $validThrough: DateTime,
        $employmentType: JobEmploymentTypeEnum,
        $baseSalaryValue: Int,
        $baseSalaryUnitText: JobSalaryUnitTextEnum,
        $seniority: String
        $commission: Int,
        $employerNote: String,
        $technicalSkills: [String],
        $softSkills: [String],
        $workMode: JobWorkModeEnum,
        $isWorkPermitRequired: Boolean,
        $lastSavedStep: JobCreationStepEnum
    ) {
      ${QUERY_SCOPE} {
        _id
        ${QUERY_NAME} (
          id: $id,
          streetAddress: $streetAddress,
          postalCode: $postalCode,
          city: $city,
          state: $state,
          country: $country,
          validThrough: $validThrough,
          employmentType: $employmentType,
          baseSalaryValue: $baseSalaryValue,
          baseSalaryUnitText: $baseSalaryUnitText,
          seniority: $seniority,
          commission: $commission,
          employerNote: $employerNote,
          technicalSkills: $technicalSkills,
          softSkills: $softSkills,
          workMode: $workMode,
          isWorkPermitRequired: $isWorkPermitRequired,
          lastSavedStep: $lastSavedStep
        ) {
          ...JobTypeAllFieldsFragment
        }
      }
    }
  `;

export default function useMutationJobUpdate() {
  return useWrappedMutation(QUERY, QUERY_SCOPE, QUERY_NAME, {
    refetchQueries: [QUERY_JOB_COUNTS_BY_STATUS]
  });
}
